// src/utils/apiBase.js
export function getApiBase() {
  return (
    import.meta?.env?.VITE_API_BASE_URL ||
    (typeof window !== "undefined" &&
    window.location.origin.includes("app.captacrm.com.br")
      ? `${window.location.origin}/api`
      : "https://api.captacrm.com.br")
  );
}

export function API(path) {
  const base = getApiBase();
  return `${base}${path?.startsWith("/") ? path : `/${path || ""}`}`;
}
